'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _message = require('antd/lib/message');
var _interface = require('./interface.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _message__default = /*#__PURE__*/_interopDefaultLegacy(_message);

var VBanner = function (_a) {
  var _b = _a.title,
      title = _b === void 0 ? '' : _b,
      _c = _a.type,
      type = _c === void 0 ? _interface.VType.default : _c,
      _d = _a.onClick,
      onClick = _d === void 0 ? function () {} : _d,
      _e = _a.onClose,
      onClose = _e === void 0 ? function () {} : _e;

  switch (type) {
    case _interface.VType.default:
      return _message__default["default"].info({
        content: title,
        onClick: onClick,
        onClose: onClose
      });

    case _interface.VType.success:
      return _message__default["default"].success({
        content: title,
        onClick: onClick,
        onClose: onClose
      });

    case _interface.VType.error:
      return _message__default["default"].error({
        content: title,
        onClick: onClick,
        onClose: onClose
      });

    case _interface.VType.warning:
      return _message__default["default"].warning({
        content: title,
        onClick: onClick,
        onClose: onClose
      });

    case _interface.VType.info:
      return _message__default["default"].info({
        content: title,
        onClick: onClick,
        onClose: onClose
      });

    default:
      return null;
  }
};
//   id = "",
//   className = "",
//   title,
//   icon,
//     subtitle,
//   type,
//   onClose,
// }) => {
//   let classList = `vbanner-wrapper ${className}`;
//   return (
//     // <div id={id} className={classList} type={VType}>
//     //   <div className="banner-icon">
//     //     <VIcon {...icon} hoverEffect={false} themeMode={true} />
//     //   </div>
//     //   <div className="banner-text-wrapper">
//     //     <div className="banner-title">{title}</div>
//     //     <div className="banner-subtitle">{subtitle}</div>
//     //   </div>
//     //   <div className="close-icon">{title}</div>
//     //   <div className="" onClick={onClose}>
//     //     <VIcon {...icon} hoverEffect={false} themeMode={true} />
//     //   </div>
//     // </div>
//   );
// };
// export default VBanner;

exports["default"] = VBanner;
